import glxTagConfiguration from 'single-asset/constants/glxTagConfiguration';
import gluTagConfiguration from 'single-asset/constants/gluTagConfiguration';

export const firstSecondOfStartDateFormatter = 'MM/DD/YYYY 00:00:00';
export const lastSecondOfStopDateFormatter = 'MM/DD/YYYY 23:23:59';
export const displayedDateFormat = 'YYYY-MM-DD HH:mm:ss';
export { glxTagConfiguration };
export { gluTagConfiguration };
